import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';

import { AdvancedSearchPageApp } from './components/advanced-search-page-app';
import { GoogleAnalytics } from '../global/functions/analytics';
import { getEpiProps } from '../global/ducks/epi-api';
import { getSearchContexts } from '../global/actions/api/search';

const advancedSearchPageApp = document.getElementById('advanced-search-app');

if (advancedSearchPageApp) {
    const root = createRoot(advancedSearchPageApp);

    const { contentId } = (window as any).bootstrap;
    const analytics = new GoogleAnalytics();
    const getEpiPropsFunc = () => fetch(getEpiProps(contentId).fetch).then(res => res.ok ? res.json() : Promise.reject(res));
    const getSearchContextsFunc = () => fetch(getSearchContexts().fetch).then(res => res.ok ? res.json() : Promise.reject(res));
    const openLinkFunc = (url: string) => window.open(url, '_self');

    root.render(
        <AdvancedSearchPageApp
            getEpiProps={getEpiPropsFunc}
            getSearchContexts={getSearchContextsFunc}
            openLink={openLinkFunc}
            analytics={analytics} />
    );
}